export default __webpack_public_path__ + "static/media/1.41925139.svg";